import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    administrator: false,
    association: {},
    dark: true,
    debug: true,
    username: '',
    userId: 0,
    memberId: 0,
    loading: false,
    loggedIn: false,
    proShop: false,
    returnUrl: '',
    selectedYear: new Date().getFullYear(),
    selectedEvent: 0,
    selectedFlight: 0,
    winningType: 0,
  },
  getters: {
    getAdministrator: state => state.administrator,
    getProShop: state => state.proShop,
    getLoggedIn: state => state.loggedIn,
    getName: state => state.username,
    getUserId: state => state.userId,
    getMemberId: state => state.memberId,
    getLoading: state => state.loading,
    getAssociation: state => state.association,
    getReturnUrl: state => state.returnUrl,
    getDark: state => state.dark,
    getSelectedYear: state => state.selectedYear,
    getSelectedEvent: state => state.selectedEvent,
    getSelectedFlight: state => state.selectedFlight,
    getWinningType: state => state.winningType
  },
  mutations: {
    setAssociation(state, data) {
      state.association = data
    },
    setDark(state, isDark) {
      state.dark = isDark
    },
    setMemberId(state, memberId){
      state.memberId = memberId
    },
    setReturnUrl(state, url) {
      state.returnUrl = url
    },
    setSelectedYear(state, year) {
      state.selectedYear = year
    },
    setSelectedEvent(state, event) {
      state.selectedEvent = event
    },
    setSelectedFlight(state, flight){
      state.selectedFlight = flight
    },
    setWinningType(state, type){
      state.winningType = type
    },
    loginUser(state, token) {
      state.loggedIn = true
      state.username = token.unique_name
      state.userId = token.USER_ID
      state.memberId = parseInt(token.MEMBER_ID)
      state.administrator = token.ACCESS_LEVEL === 'Administrator'
      state.proShop = token.ACCESS_LEVEL === "Pro Shop"
    },
    logoutUser(state) {
      state.loggedIn = false
      state.administrator = false
      state.proShop = false
      state.username = ''
    },
    isAdministrator(state) {
      state.proShop = false
      state.administrator = true
    },
    notAdministrator(state) {
      state.administrator = false
    },
    isProShop(state) {
      state.administrator = false
      state.proShop = true
    },
    notProShop(state) {
      state.proShop = false
    },
    isLoading(state) {
      state.loading = true
    },
    notLoading(state) {
      state.loading = false
    }
  },
  actions: {},
  modules: {}
})
